import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ListGroup, ListGroupItem } from "reactstrap";

class Search extends React.Component {
  render() {
    const results = this.props.results;
    if (results === null) {
      return null;
    }
    if (results.length === 0) {
      return (
        <div className="results-message lead text-center">
          ¿No encuentras tu profesor?
          <Link className="nav-link" to="/suggestions/new">
            Sugiérelo aquí.
          </Link>
        </div>
      );
    }

    const universityId = this.props.universityId;
    const query = this.props.query;
    var listGroupItems = [];
    for (let p of results) {
      listGroupItems.push(
        <ListGroupItem key={p.id} action>
          <Link
            to={`/universities/${universityId}/professors/${p.id}?q=${query}`}
          >
            Prof. {p.firstName} {p.lastName}{" "}
            <small className="text-muted">({p.departmentName})</small>
          </Link>
        </ListGroupItem>
      );
    }
    return <ListGroup>{listGroupItems}</ListGroup>;
  }
}

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => {
  return {};
};

const SearchContainer = connect(mapStateToProps, mapDispatchToProps)(Search);

export default SearchContainer;



// WEBPACK FOOTER //
// ./src/containers/SearchContainer.js